import { useEffect } from 'react';
import { socket } from "../../socket";

export const useSocket = (userId) => {
  useEffect(() => {
    if (!userId) {
      console.log("🚪 User logged out → leaving all rooms");
      socket.emit("leaveAllUserRooms");
      return;
    }

    console.log(`🟢 Joining socket room for user_${userId}`);
    socket.emit("joinUserRoom", { userId });

    const handleConnect = () => console.log("🟢 Socket connected");
    const handleDisconnect = () => console.log("🔴 Socket disconnected");

    socket.on("connect", handleConnect);
    socket.on("disconnect", handleDisconnect);

    return () => {
      console.log(`🚪 Leaving socket room for user_${userId}`);
      socket.emit("leaveUserRoom", { userId });
      socket.off("connect", handleConnect);
      socket.off("disconnect", handleDisconnect);
    };
  }, [userId]);
};
